import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListSubmissionsByBounty = (params) => {
  return async () => {
    const { bountyId, page, limit } = params;
    
    return client
      .api(`/bounty/${bountyId}/get-submission-result`, 'get', { headers: await cognito.getHeaderAuthorization() })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};
